<template>
    <div>
        <h2>{{ step.title }}</h2>
        <p>If you need to leave this page, your answers will be saved for 24 hours.</p>
        <InputRadioGroup
            name="how_did_you_hear_about_us"
            :required="checkIsRequired('how_did_you_hear_about_us')"
            :error="formRef.errors.get('how_did_you_hear_about_us')"
            v-model="formRef.how_did_you_hear_about_us"
            v-model:other-text="formRef.heard_other_text"
            :form="formRef"
            :options="getField('how_did_you_hear_about_us')['options']"
            @input="formRef.errors.clear('how_did_you_hear_about_us')"
        >
            <template v-slot:question>
                {{ getField("how_did_you_hear_about_us").question }}
            </template>
        </InputRadioGroup>
    </div>
</template>

<script setup>
import InputRadioGroup from "../../../Form/InputRadioGroup";
import Form from "../../../../Form";
import { isRequired } from "./formHelper.js";
import { ref, markRaw } from "vue";

const props = defineProps({
    step: Object,
    fields: Object,
    formData: Object
})

let formRef = markRaw(ref(new Form({
    how_did_you_hear_about_us: null,
    heard_other_text: null
}, props.formData)))

const getField = (fieldName) => {
    return props.fields[fieldName];
}

const checkIsRequired = (fieldName) => {
    var fieldData = getField(fieldName);
    return isRequired(fieldData, formRef.value);
}

defineExpose({
  formRef
})
</script>